import { Consts } from '@/consts';

export class StoreUtils {
	/**
	 * Can use All Available Storage Check.
	 */
	public static canUseStoreFunction(): boolean {
		return StoreUtils.canUseCookie() && StoreUtils.canUseLocalStorage() && StoreUtils.canUseSessionStorage();
	}

	// /**
	// /* Using js-cookie
	//  * Store Value in Labeled Cookie.
	//  * @param key Cookie Label
	//  * @param object Stored Object
	//  * @param expire Expiration Time
	//  */
	// public static setCookie(key: string, object: any, expire?: Date): boolean {
	// 	if ((!StoreUtils.canUseCookie()) || (key === Consts.EMPTY_STRING)) {
	// 		return false;
	// 	}
	// 	if (expire) {
	// 		Cookies.set(key, object, { expires: expire });
	// 	} else {
	// 		Cookies.set(key, object);
	// 	}
	// 	return true;
	// }

	// /**
	//  * Using js-cookie
	//  * Get Value in Labeled Cookie.
	//  * @param key Cookie Label
	//  */
	// public static getCookie(key: string): any {
	// 	if ((!StoreUtils.canUseCookie()) || (key === Consts.EMPTY_STRING)) {
	// 		return null;
	// 	}
	// 	return Cookies.get(key);
	// }

	// /**
	//  * Using js-cookie
	//  * Remove Cookie.
	//  * @param key Cookie Label
	//  */
	// public static removeCookie(key: string): void {
	// 	if ((!StoreUtils.canUseCookie()) || (key === Consts.EMPTY_STRING)) {
	// 		//return false;
	// 	}
	// 	return Cookies.remove(key);
	// }

	/**
	 * Store Value in Labeled Browser Local(Web) Storage.
	 * @param key Storage Label
	 * @param object Stored Object
	 */
	public static setLocalStorage<T>(key: string, data: string | T): boolean {
		if ((!StoreUtils.canUseLocalStorage()) || (key === Consts.EMPTY_STRING) || (data === undefined) || (data === null)) {
			return false;
		}
		if (typeof data === 'string') {
			localStorage.setItem(key, data);
		} else {
			const jsonString = JSON.stringify(data);
			localStorage.setItem(key, jsonString);
		}
		return true;
	}

	/**
	 * Get Value in Labeled Browser Local(Web) Storage.
	 * @param key Storage Label
	 */
	public static getLocalStorage(key: string): string {
		if ((!StoreUtils.canUseLocalStorage()) || (key === Consts.EMPTY_STRING)) {
			return Consts.EMPTY_STRING;
		}
		const item: string | null = localStorage.getItem(key);
		if (item === null) {
			return Consts.EMPTY_STRING;
		}
		return item;
	}

	/**
	 * Get Value in Labeled Browser Local(Web) Storage.
	 * @param key Storage Label
	 */
	public static getLocalStorageAndJsonParse<T>(key: string): T | null {
		if ((!StoreUtils.canUseLocalStorage()) || (key === Consts.EMPTY_STRING)) {
			return null;
		}
		const item: string | null = localStorage.getItem(key);
		if ((item === null) || (item === Consts.EMPTY_STRING)) {
			return null;
		}
		try {
			return JSON.parse(item) as T;
		} catch (e) {
			return null;
		}
	}

	/**
	 * Remove Value from Storage.
	 * @param key Storage Label
	 */
	public static removeLocalStorage(key: string): boolean {
		if ((!StoreUtils.canUseLocalStorage()) || (key === Consts.EMPTY_STRING)) {
			return false;
		}
		localStorage.removeItem(key);
		return true;
	}

	/**
	 * Store Value in Labeled Browser Session Storage.
	 * @param key Storage Label
	 * @param object Stored Object
	 */
	public static setSessionStorage<T>(key: string, data: string | T): boolean {
		if ((!StoreUtils.canUseSessionStorage()) || (key === Consts.EMPTY_STRING)
			|| (data === undefined) || (data === null)) {
			return false;
		}
		if (typeof data === 'string') {
			sessionStorage.setItem(key, data);
		} else {
			const jsonString = JSON.stringify(data);
			sessionStorage.setItem(key, jsonString);
		}
		return true;
	}

	/**
	 * Get Value in Labeled Browser Session Storage.
	 * @param key Storage Label
	 */
	public static getSessionStorage(key: string): string {
		if ((!StoreUtils.canUseSessionStorage()) || (key === Consts.EMPTY_STRING)) {
			return Consts.EMPTY_STRING;
		}
		const item: string | null = sessionStorage.getItem(key);
		if (item === null) {
			return Consts.EMPTY_STRING;
		}
		return item;
	}

	/**
	 * Get Value in Labeled Browser Session Storage.
	 * @param key Storage Label
	 */
	public static getSessionStorageAndJsonParse<T>(key: string): T | null {
		if ((!StoreUtils.canUseSessionStorage()) || (key === Consts.EMPTY_STRING)) {
			return null;
		}
		const item: string | null = sessionStorage.getItem(key);
		if ((item === null) || (item === Consts.EMPTY_STRING)) {
			return null;
		}
		try {
			return JSON.parse(item) as T;
		} catch (e) {
			return null;
		}
	}

	/**
	 * Remove Value from Storage.
	 * @param key Storage Label
	 */
	public static removeSessionStorage(key: string): boolean {
		if ((!StoreUtils.canUseSessionStorage()) || (key === Consts.EMPTY_STRING)) {
			return false;
		}
		sessionStorage.removeItem(key);
		return true;
	}

	/**
	 * Are Cookies Available Check.
	 */
	private static canUseCookie(): boolean {
		if (navigator.cookieEnabled) {
			// $.cookie('check', true);
			// if ($.cookie('check')) {
			// 	return true;
			// }
			return true;
		}
		return false;
	}

	/**
	 * Is Browser Local Storage Available Check.
	 */
	private static canUseLocalStorage(): boolean {
		try {
			if (localStorage) {
				return true;
			}
		} catch (e) {
			// console.log(e);
		}
		return false;
	}

	/**
	 * Is Browser Session Storage Available Check.
	 */
	private static canUseSessionStorage(): boolean {
		try {
			if (sessionStorage) {
				return true;
			}
		} catch (e) {
			// console.log(e);
		}
		return false;
	}
}
